import { render, staticRenderFns } from "./CaseRequestFields.vue?vue&type=template&id=20c02ce9&scoped=true&"
import script from "./CaseRequestFields.vue?vue&type=script&lang=js&"
export * from "./CaseRequestFields.vue?vue&type=script&lang=js&"
import style0 from "./CaseRequestFields.vue?vue&type=style&index=0&id=20c02ce9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c02ce9",
  null
  
)

export default component.exports